import { Component, ViewEncapsulation, ChangeDetectorRef, Renderer2 } from '@angular/core';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { InventoryService } from '@app/cp/shared/services/inventory.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { DispatchCustPartsBus } from '@app/cp/shared/models/DispatchCustPartsBus';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { MSFilterClass } from '@app/cp/shared/classes/filters/MSFilterClass';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { NoteUpd } from '../../../shared/models/NoteUpd';
import { UseFeatureFlagSet, IFeatureFlagSet } from '@app/cp/shared/decorators/featureflags/featureflagset-decorator';

@UseFeatureFlagSet()
@Component({
    selector: 'dispatch-customer-supplied-parts',
    templateUrl: './dispatch-customer-supplied-parts.component.html',
    styleUrls: ['./dispatch-customer-supplied-parts.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DispatchCustomerSuppliedPartsComponent extends BaseGridEditLineComponent<DispatchCustPartsBus, null, DispatchesService>  {
    compFeatureFlagSet: IFeatureFlagSet = this as any;
    supplierFC: MSFilterClass = new MSFilterClass('supplierId');

    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: DispatchesService, svc_inv: InventoryService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;

      this.className = "DispatchCustPartsBus";
      this.appCode = "DispatchCustomerParts"
      this.appName = "Dispatch Customer Supplied Parts";
      this.inventorySvcField = "inventoryNumber";

    }
    createForm() {
        this.editForm = new UntypedFormGroup({
            'dispatchCustPartId': new UntypedFormControl(),
            'dispatchId': new UntypedFormControl(),
            'inventoryId': new UntypedFormControl(),
            'inventoryNumber': new UntypedFormControl(),
            'refNbr': new UntypedFormControl(),
            'partInfo': new UntypedFormControl(),
            'eta': new UntypedFormControl(),
            'note': new UntypedFormControl(),
            'rcvdPersonId': new UntypedFormControl(),
            'isRcvd': new UntypedFormControl(false),
            'qtyRcvd': new UntypedFormControl(),
            'quantity': new UntypedFormControl(),
            'qtyUsed': new UntypedFormControl(),
            'supplierId': new UntypedFormControl(),
            'insertDt': new UntypedFormControl(),
            'insertUserId': new UntypedFormControl(),
            'updateDt': new UntypedFormControl(),
            'updateUserId': new UntypedFormControl(),
            'personName': new UntypedFormControl(),
            'reducedPartNote': new UntypedFormControl()

        });

    }
    setForm() {
        this.editForm.patchValue({
            dispatchCustPartId: this.selectedData.dispatchCustPartId,
            dispatchId: this.selectedData.dispatchId,
            inventoryId: this.selectedData.inventoryId,
            inventoryNumber: this.selectedData.inventoryNumber,
            refNbr: this.selectedData.refNbr,
            partInfo: this.selectedData.partInfo,
            note: CommonFunctions.getStringValueIfNull(this.selectedData.note),
            eta: this.selectedData.eta,
            rcvdPersonId: this.selectedData.rcvdPersonId,
            isRcvd: this.selectedData.isRcvd,
            qtyRcvd: this.selectedData.qtyRcvd,
            quantity: this.selectedData.quantity,
            qtyUsed: this.selectedData.qtyUsed,
            supplierId: this.selectedData.supplierId,
            insertDt: this.selectedData.insertDt,
            insertUserId: this.selectedData.insertUserId,
            updateDt: this.selectedData.updateDt,
            updateUserId: this.selectedData.updateUserId,
            personName: this.selectedData.personName,
            reducedPartNote: this.selectedData.reducedPartNote
        });
    }
    setFromReferenceData(data: DispatchCustPartsBus) {
        data.personName = this.personName(data.rcvdPersonId);
        return data;
    }
    getChangedObject(dataObj: DispatchCustPartsBus) {
        let busObj: DispatchCustPartsBus = new DispatchCustPartsBus(dataObj);
        busObj.setBeforeSave();
        return busObj;
    }
    protected save(dataObj: DispatchCustPartsBus) {

        let busObj: DispatchCustPartsBus = this.getChangedObject(dataObj);
        this.svc_data.saveCustParts(busObj).subscribe((data: BaseMessageInfo) => {
            if (!data.saveError) {
                let dataObj: DispatchCustPartsBus = new DispatchCustPartsBus(data.primaryReturn);
                this.saveSuccess(dataObj);
            }
            else {
                this.saveError(dataObj, data.message);
            }
        })
    }
    deleteIndividual(data: DispatchCustPartsBus) {
        if (data.hasId) {
            this.svc_data.deleteCustParts(data.dispatchCustPartId).subscribe((dataObj: BaseMessageInfo) => {
                if (!dataObj.saveError) {
                    this.deleteSuccess(data);
                    this.removeLocal(data);
                }
                else {
                    this.deleteError(data, dataObj.message);

                }
            });
        }
        else {
            this.closeEditor();
        }
    }
    supplier(id: any) {
        return this.referenceData.suppliers.find(x => x.value === id);
    }
    noteActive: boolean = false;
    noteUpd: NoteUpd = null;
    noteOpen(data: DispatchCustPartsBus) {
        let noteUpd: NoteUpd = new NoteUpd();
        noteUpd.notes = data.note;
        this.genericOpenCtrl(null);
        this.noteActive = true;
        this.noteUpd = noteUpd;
    }
    noteClose(noteUpd: NoteUpd) {
        if (CommonFunctions.hasValue(noteUpd)) {
            this.editForm.patchValue({
                note: noteUpd.notes
            });
            this.setDirty();
        }
        this.noteActive = false;
        setTimeout(() => {
            this.genericCloseCtrl(null);
        });
    }
    rpNoteActive: boolean = false;
    rpNoteUpd: NoteUpd = null;
    rpNoteOpen(data: DispatchCustPartsBus) {
        let noteUpd: NoteUpd = new NoteUpd();
        noteUpd.notes = data.reducedPartNote;
        this.genericOpenCtrl(null);
        this.rpNoteActive = true;
        this.rpNoteUpd = noteUpd;
    }
    rpNoteClose(noteUpd: NoteUpd) {
        if (CommonFunctions.hasValue(noteUpd) && CommonFunctions.hasStringValueLength(noteUpd.notes,3)) {
            this.editForm.patchValue({
                reducedPartNote: noteUpd.notes
            });
            this.setDirty();
        }
        else {
            this.editForm.patchValue({
                reducedPartNote: null,
                qtyUsed: this.selectedData.qtyUsed
            });
        }
        this.rpNoteActive = false;
        setTimeout(() => {
            this.genericCloseCtrl(null);
        });
    }
    currEditFormValues: any;
    protected beforeInventorySearchSetForm() {
        if (this.editForm) {
            this.currEditFormValues = this.editForm.value;
        }
        else {
            this.currEditFormValues = null;
        }
    }
    protected afterSetInventorySearchData() {
        try {
            if (this.hasGridData && this.hasEditForm) {
                this.gridData[this.editedRowIndex].refNbr = this.selectedData.refNbr;
            }
        }
        catch (err) {

        }
    }
    onBlur(event, dataItem: DispatchCustPartsBus, editForm: UntypedFormGroup, field: string) {
        console.log("onBlur:", editForm.get(field).value, dataItem[field]);
        let isAdded = !CommonFunctions.hasValue(dataItem.hasId);
        if (editForm.get(field).value !== dataItem[field] && !isAdded) {
            var valNew = editForm.get(field).value;
            var valOrig = dataItem[field];
            if (field == 'qtyUsed' && valNew < valOrig) {
                this.partQuantityChanged(valNew, valOrig);
            }
        }
    }
    partQuantityChanged(qtyTo: number, qtyFrom: number) {
        if (qtyTo < qtyFrom) {
            this.rpNoteOpen(this.selectedData);
        }
    }
}
